"use client";

import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion, useAnimate } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { useClickAway, useKeyPressEvent } from "react-use";
import { UserPageStatsActivityWalletFilterType } from "../UserPageStatsActivityWallet";
import UserPageStatsActivityWalletFilterItem from "./UserPageStatsActivityWalletFilterItem";
export default function UserPageStatsActivityWalletFilter(t0) {
  const $ = _c(29);
  const {
    activeFilter,
    setActiveFilter
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [UserPageStatsActivityWalletFilterType.ALL]: "All",
      [UserPageStatsActivityWalletFilterType.AIRDROPS]: "Airdrops",
      [UserPageStatsActivityWalletFilterType.MINTS]: "Mints",
      [UserPageStatsActivityWalletFilterType.SALES]: "Sales",
      [UserPageStatsActivityWalletFilterType.PURCHASES]: "Purchases",
      [UserPageStatsActivityWalletFilterType.TRANSFERS]: "Transfers",
      [UserPageStatsActivityWalletFilterType.BURNS]: "Burns"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const ACTIVITY_WALLET_FILTER_TYPE_TO_TITLE = t1;
  const [isOpen, setIsOpen] = useState(false);
  const [iconScope, animateIcon] = useAnimate();
  let t2;
  if ($[1] !== isOpen) {
    t2 = () => setIsOpen(!isOpen);
    $[1] = isOpen;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const toggleOpen = t2;
  let t3;
  if ($[3] !== animateIcon || $[4] !== iconScope || $[5] !== isOpen) {
    t3 = () => {
      if (isOpen) {
        animateIcon(iconScope.current, {
          rotate: 0
        });
      } else {
        animateIcon(iconScope.current, {
          rotate: -90
        });
      }
    };
    $[3] = animateIcon;
    $[4] = iconScope;
    $[5] = isOpen;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(t3);
  const listRef = useRef(null);
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsOpen(false);
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useClickAway(listRef, t4);
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsOpen(false);
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  useKeyPressEvent("Escape", t5);
  let t6;
  if ($[9] !== setActiveFilter) {
    t6 = filter => {
      setActiveFilter(filter);
      setIsOpen(false);
    };
    $[9] = setActiveFilter;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const onFilter = t6;
  const t7 = ACTIVITY_WALLET_FILTER_TYPE_TO_TITLE[activeFilter];
  let t8;
  if ($[11] !== t7) {
    t8 = <span>{t7}</span>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8 || $[14] !== toggleOpen) {
    t9 = <button type="button" onClick={toggleOpen} className="tw-relative tw-flex tw-items-center tw-w-full tw-rounded-lg tw-border-0 tw-py-2.5 tw-px-3.5 tw-bg-iron-900  tw-text-iron-50 tw-font-medium tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700 placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-bg-transparent focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 hover:tw-ring-iron-600 tw-text-base sm:tw-leading-6 tw-transition tw-duration-300 tw-ease-out">{t8}</button>;
    $[13] = t8;
    $[14] = toggleOpen;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== iconScope) {
    t11 = <div className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-3.5"><svg ref={iconScope} className="tw-h-5 tw-w-5 tw-text-white" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">{t10}</svg></div>;
    $[17] = iconScope;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== activeFilter || $[20] !== isOpen || $[21] !== onFilter) {
    t12 = isOpen && <motion.div className="tw-origin-top-right tw-absolute tw-z-10 tw-right-0 tw-mt-1 tw-w-full tw-rounded-lg tw-shadow-xl tw-bg-iron-800 tw-ring-1 tw-ring-black tw-ring-opacity-5" initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -20
    }} transition={{
      duration: 0.2
    }}><div className="tw-absolute tw-z-10 tw-mt-1 tw-overflow-hidden tw-w-full tw-rounded-md tw-bg-iron-800 tw-shadow-2xl tw-ring-1 tw-ring-white/10"><div className="tw-py-1 tw-flow-root tw-max-h-[calc(16rem+_-10svh)] tw-overflow-x-hidden tw-overflow-y-auto"><ul className="tw-flex tw-flex-col tw-px-2 tw-mx-0 tw-mb-0 tw-list-none">{Object.values(UserPageStatsActivityWalletFilterType).map(filter_0 => <UserPageStatsActivityWalletFilterItem key={`nft-activity-${filter_0}`} filter={filter_0} title={ACTIVITY_WALLET_FILTER_TYPE_TO_TITLE[filter_0]} activeFilter={activeFilter} onFilter={onFilter} />)}</ul></div></div></motion.div>;
    $[19] = activeFilter;
    $[20] = isOpen;
    $[21] = onFilter;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12) {
    t13 = <AnimatePresence mode="wait" initial={false}>{t12}</AnimatePresence>;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t11 || $[26] !== t13 || $[27] !== t9) {
    t14 = <div className="tw-w-full sm:tw-max-w-xs" ref={listRef}><div className="tw-relative">{t9}{t11}{t13}</div></div>;
    $[25] = t11;
    $[26] = t13;
    $[27] = t9;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
}